<template>
  <VaModal v-if="mounted" v-model="visible" hide-default-actions>
    <div class="flex flex-col gap-3">
      <h2 v-if="results.length">{{ t('podcasts.search.resultsTitle') }}</h2>
      <p v-else>{{ t('podcasts.search.noResults') }}</p>

      <button
        v-for="result in results"
        :key="result.rss_url"
        type="button"
        class="flex flex-row items-center gap-4 p-3 rounded-2xl bg-neutral-700 text-left hover:bg-neutral-600 transition-colors duration-200"
        @click="emit('choose', result)"
      >
        <img
          v-if="result.image_url"
          :src="result.image_url"
          :alt="result.name"
          class="w-16 h-16 rounded-xl object-cover flex-shrink-0"
          loading="lazy"
        >
        <div class="min-w-0">
          <div class="font-bold truncate">{{ result.name }}</div>
          <div v-if="result.author" class="text-sm text-neutral-300 truncate">{{ result.author }}</div>
        </div>
      </button>
    </div>

    <template #footer>
      <VaButton :preset="results.length ? 'plain' : 'primary'" @click="emit('manual')">
        {{ t('podcasts.search.notListed') }}
      </VaButton>
    </template>
  </VaModal>
</template>

<script lang="ts" setup>
import { VaButton, VaModal } from 'vuestic-ui'
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import PodcastSearchResult from '@/models/PodcastSearchResult'

const props = defineProps<{
  modelValue: boolean
  results: PodcastSearchResult[]
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'choose', result: PodcastSearchResult): void
  (e: 'manual'): void
}>()

const { t } = useI18n()

const visible = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
})

// Gates the modal. false during SSR and the client's first (hydration) render;
// VaModal teleports on the client but renders inline on the server, so leaving
// it in the hydrated tree mismatches.
const mounted = ref(false)
onMounted(() => {
  mounted.value = true
})
</script>
